// @docs https://[domain]/api/v1/docs
export default {
  List: "/pyr/employee-productivity-templates",
  Detail: "/pyr/employee-productivity-templates/{id}",
  Active: "/pyr/employee-productivity-templates/{id}/active",
  Delete: "/pyr/employee-productivity-templates/{id}/{templateCode}/{empCode}",
  Inactive: "/pyr/employee-productivity-templates/{id}/inactive",
  Assign: "/pyr/employee-productivity-templates",
  AssignTemplates: "/pyr/employee-productivity-templates/assign",
  RemoveTemplates: "/pyr/employee-productivity-templates/remove",
};
